import { render, staticRenderFns } from "./UpdateCompanyProfile.vue?vue&type=template&id=1fb1f6c8&scoped=true&"
import script from "./UpdateCompanyProfile.vue?vue&type=script&lang=js&"
export * from "./UpdateCompanyProfile.vue?vue&type=script&lang=js&"
import style0 from "./UpdateCompanyProfile.vue?vue&type=style&index=0&id=1fb1f6c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb1f6c8",
  null
  
)

export default component.exports